import React from 'react';
import { Section, SectionTitle } from '@repo/components/containers';
import logoIcons from '@repo/icons/SocialIcons';
import analytics from '@repo/utils/helpers/analytics';
import Contact from '@repo/utils/models/Contact';
import styles from './ContactSocialProfiles.module.scss';

function handleClick(contact) {
  analytics.track('Contact Social Tapped', { contactId: contact.objectID });
}

export function ContactSocialProfiles({
  contact,
  underline = true,
}: {
  contact: Contact;
  underline?: boolean;
}) {
  const social = contact.socialProfiles;

  if (social.length === 0) {
    return null;
  }

  return (
    <Section>
      <SectionTitle underline={underline}>Social</SectionTitle>
      <div className={styles.items}>
        {social.map((item, i) => {
          const LogoIcon = logoIcons[item.platform];

          return (
            <a
              onClick={() => handleClick(contact)}
              className={styles.item}
              key={i}
              href={item.url}
              target="_blank"
            >
              <LogoIcon className={styles.logo} />
            </a>
          );
        })}
      </div>
    </Section>
  );
}
